module.exports = __webpack_public_path__ + "img/14.6baa0475.webp";